import { Dropdown, Space, type DropdownProps } from 'antd';
import classNames from 'classnames';
import { CSSProperties, forwardRef } from 'react';
import styles from './index.module.scss';

interface Props extends DropdownProps {
  className?: string;
  overlayClassName?: string;
  dropdownItem: React.JSX.Element;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  trigger?: ('click' | 'hover' | 'contextMenu')[];
  onClick?: (e: React.MouseEvent<Element, MouseEvent>) => void;
  customPosition?: CSSProperties;
}

const DropDown = forwardRef<HTMLDivElement, Props>(
  (
    {
      className,
      children,
      dropdownItem,
      isOpen,
      onOpenChange,
      trigger = ['click'],
      overlayClassName,
      onClick,
      customPosition,
      ...props
    },
    ref,
  ) => {
    return (
      <Space
        ref={ref}
        direction='vertical'
        style={customPosition}
        onClick={onClick}
        className={className}>
        <Space wrap>
          <Dropdown
            {...props}
            dropdownRender={() => (
              <div className={classNames(styles.dropdownMenu, overlayClassName)}>
                {dropdownItem}
              </div>
            )}
            open={isOpen}
            trigger={trigger}
            onOpenChange={onOpenChange}>
            <div className={styles.overlay}>{children}</div>
          </Dropdown>
        </Space>
      </Space>
    );
  },
);

DropDown.displayName = 'DropDown';

export default DropDown;
